import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/components/Home'),
  },
  {
    path: '/Dataset',
    component: () => import('@/components/Dataset'),
  },
  {
    path: '/Gene',
    name:'Gene',
    component: () => import('@/components/Gene'),
    meta:{
      keepAlive: true
    }
  },
  {
    path: '/Geneset',
    name:'Geneset',
    component: () => import('@/components/Geneset'),
  },
  {
    path: '/Custom',
    name:'Custom',
    component: () => import('@/components/Custom'),
  },
  {
    path: '/Subtype',
    name:'Subtype',
    component: () => import('@/components/Subtype'),
    meta:{
      keepAlive: true
    }
  },
  {
    path: '/Modelconstruction',
    name:'Modelconstruction',
    component: () => import('@/components/Modelconstruction'),
    meta:{
      keepAlive: true
    }
  },
  {
    path: '/antiPD',
    name:'antiPD',
    component: () => import('@/components/antiPD'),
  },
  {
    path: '/Contact',
    name:'Contact',
    component: () => import('@/components/Contact'),
  },
  {
    path: '/testTable',
    component: () => import('@/components/geneTable.vue'),
  },
  {
    path: '/PD1project',
    name: 'PD1project',
    component: () => import('@/components/PDres.vue'),
  },
  {
    path: '/PD1result',
    name: 'PD1result',
    component: () => import('@/components/PD1result.vue'),
  },
  {
    path: '/Mutation',
    name: 'Mutation',
    component: () => import('@/components/Mutation'),
  },
  {
    path: '/CNV',
    name: 'CNV',
    component: () => import('@/components/CNV'),
  },
  {
    path: '/Datasetsingle',
    name: 'Datasetsingle',
    component: () => import('@/components/Datasetsingle'),
  },
  {
    path: '/Statistics',
    name: 'Statistics',
    component: () => import('@/components/Statistics'),
  },
  {
    path: '/Tutorial',
    name: 'Tutorial',
    component: () => import('@/components/Tutorial'),
  },
  
]


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router






// WEBPACK FOOTER //
// ./src/router/index.js